module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "qrtb-box"
  }, [_c('div', {
    staticClass: "qrtb-content"
  }, [_c('div', {
    staticClass: "qrtb-coin-card"
  }, [_c('div', {
    staticClass: "qrtb-coin-icon"
  }, [_vm._v("NB")]), _vm._v(" "), _c('div', {
    staticClass: "qrtb-coin-info"
  }, [_c('span', {
    staticClass: "qrtb-coin-name"
  }, [_vm._v("NB Chain")]), _vm._v(" "), _c('span', {
    staticClass: "qrtb-coin-desc"
  }, [_vm._v(_vm._s(_vm.$t('all.lianshangbaobishibei')))])])]), _vm._v(" "), _c('div', {
    staticClass: "qrtb-info-item"
  }, [_c('span', {
    staticClass: "qrtb-info-label"
  }, [_vm._v(_vm._s(_vm.$t('all.bizhong')))]), _vm._v(" "), _c('span', {
    staticClass: "qrtb-info-value"
  }, [_vm._v("NB")])]), _vm._v(" "), _c('div', {
    staticClass: "qrtb-info-item"
  }, [_c('span', {
    staticClass: "qrtb-info-label"
  }, [_vm._v(_vm._s(_vm.$t('all.shuliang')))]), _vm._v(" "), _c('span', {
    staticClass: "qrtb-info-value"
  }, [_vm._v("+1000.00")])]), _vm._v(" "), _c('div', {
    staticClass: "qrtb-info-item"
  }, [_c('span', {
    staticClass: "qrtb-info-label"
  }, [_vm._v(_vm._s(_vm.$t('all.wangluo')))]), _vm._v(" "), _c('span', {
    staticClass: "qrtb-info-value"
  }, [_vm._v("NB Chain")])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "qrtb-info-item"
  }, [_c('span', {
    staticClass: "qrtb-info-label"
  }, [_vm._v(_vm._s(_vm.$t('all.shijian')))]), _vm._v(" "), _c('span', {
    staticClass: "qrtb-info-value"
  }, [_vm._v("2026/06/10 13:20")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "qrtb-info-item"
  }, [_c('span', {
    staticClass: "qrtb-info-label"
  }, [_vm._v("TxHash")]), _vm._v(" "), _c('span', {
    staticClass: "qrtb-info-value qrtb-text-green"
  }, [_vm._v("0x82...8F91")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4afefa8c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/pages/querentbi/querentbi.vue
// module id = 976
// module chunks = 1